import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../iconify';
import IconWithText from '../../components/dashboard/orders/order/IconWithText';

const WEATHER_ICONS = {
  clear: 'fluent-mdl2:sunny',
  sunny: 'fluent-mdl2:sunny',
  cloudy: 'fluent-mdl2:partly-cloudy-day',
  rain: 'fluent-mdl2:rain-showers-day',
  showers: 'fluent-mdl2:rain-showers-day',
  snow: 'fluent-mdl2:snowflake',
  fog: 'fluent-mdl2:fog',
  thunder: 'fluent-mdl2:thunderstorms-day',
};

const getWeatherIcon = (description) => {
  if (!description) return 'fluent-mdl2:partly-cloudy-day';
  const lowerDesc = description.toLowerCase();
  return Object.entries(WEATHER_ICONS).find(([key]) => lowerDesc.includes(key))?.[1] || 'fluent-mdl2:partly-cloudy-day';
};

export default function WeatherInfo({ loading, hasFetchedWeather, weatherInfo, stateAlerts = [], zip, clickable = true, variant = 'body2' }) {

  const openWeatherSite = (e) => {
    if (!clickable || !zip) return;
    e.stopPropagation();
    window.open(`https://weather.com/weather/today/l/${zip}`, '_blank');
  };

  if (stateAlerts.length > 0) return <Tooltip title={stateAlerts[0].headline || 'Weather Alert'} arrow>
    <Box sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', py: 0.5, maxWidth: '100%' }}>
      <IconButton size="small" color="error" sx={{ p: 0, mr: 0.5, minWidth: 16 }} onClick={openWeatherSite}>
        <Iconify icon={stateAlerts[0].icon} width={16} height={16} />
      </IconButton>
      <Typography variant={variant} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>
        {stateAlerts[0].headline}
      </Typography>
    </Box>
  </Tooltip>;

  if (weatherInfo) return <Tooltip title={weatherInfo.shortForecast} arrow> 
    <Typography sx={{ py: 0.5, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant={variant} component="div">
      <Box component="span" sx={{ mr: 0.5, minWidth: 16 }}>
        <Iconify sx={{ mb: "-3px" }} icon={getWeatherIcon(weatherInfo.shortForecast)} onClick={openWeatherSite} width={16} height={16} color="secondary" />
      </Box>
      {weatherInfo.shortForecast}
    </Typography>
  </Tooltip>;

  return <IconWithText variant={variant} icon="fluent-mdl2:partly-cloudy-day" text={loading && !hasFetchedWeather ? "Loading weather..." : "Weather unavailable"} />
}

WeatherInfo.propTypes = {
  loading: PropTypes.bool,
  hasFetchedWeather: PropTypes.bool,
  zip: PropTypes.string,
  clickable: PropTypes.bool,
  weatherInfo: PropTypes.object,
  stateAlerts: PropTypes.array,
  variant: PropTypes.string
};
